import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import { Box, Flex } from "rebass/styled-components";
import { HiExclamation } from "react-icons/hi";
import { createPortal } from "react-dom";

import { ClipQualityIcon } from "../Icons";
import { useClipQualityConfigs } from "MVVM/Hooks/useClipQualityConfigs";
import { ClipQualitySettingsModal } from "./index";

export const ClipQualityBubble = () => {
  const { configs, currentConfig, needsConfChange } = useClipQualityConfigs();
  const [modalOpen, setModalOpen] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  if (!needsConfChange || dismissed) return null;

  const isUnset = !currentConfig;

  return (
    <>
      <BubbleContainer onClick={() => setModalOpen(true)}>
        <BubbleIcon>
          <ClipQualityIcon size={20} />
        </BubbleIcon>
        <BubbleText>
          {isUnset
            ? "Set your clip quality settings"
            : "Update your clip quality settings"}
        </BubbleText>
        {isUnset ? (
          <NewPill>NEW</NewPill>
        ) : (
          <WarningIcon>
            <HiExclamation size={14} />
          </WarningIcon>
        )}
      </BubbleContainer>
      {modalOpen &&
        createPortal(
          <ClipQualitySettingsModal onClose={() => setModalOpen(false)} />,
          document.getElementById("root") || document.body,
        )}
    </>
  );
};

const slideIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const BubbleContainer = styled(Flex)`
  align-items: center;
  animation: ${slideIn} 0.3s ease-out;
  background: ${({ theme }) => theme.colors.ned};
  border: 1px solid ${({ theme }) => theme.colors.envyAlpha30};
  border-radius: 999px;
  box-shadow: 2px 10px 30px #10181d;
  cursor: pointer;
  gap: 8px;
  padding: 8px 16px 8px 12px;
  transition:
    border-color 0.2s,
    transform 0.2s;

  &:hover {
    border-color: ${({ theme }) => theme.colors.envy};
    transform: scale(1.02);
  }
`;

const BubbleIcon = styled(Flex)`
  align-items: center;
  color: ${({ theme }) => theme.colors.envy};
`;

const BubbleText = styled(Box)`
  color: ${({ theme }) => theme.colors.ice};
  font-family: "Barlow", sans-serif;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
`;

export const NewPill = styled(Box)`
  background: ${({ theme }) => theme.colors.envy};
  border-radius: 999px;
  color: white;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 2px 6px;
  text-transform: uppercase;
`;

export const WarningIcon = styled(Flex)`
  align-items: center;
  color: #f5a623;
`;
